import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.parse-int";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeEntityScaffold } from '@classpass/saga-tools';
import { isEmpty } from 'helpers/verify';
var IMMEDIATELY = 'immediately';
export var createSubscription = makeEntityScaffold('SAGA.API.CREATE_SUBSCRIPTION', function (client, _ref) {
  var consents = _ref.consents,
      conversion = _ref.conversion,
      effective = _ref.effective,
      giftCode = _ref.giftCode,
      livePlanId = _ref.livePlanId,
      locationId = _ref.locationId,
      msaId = _ref.msaId,
      planId = _ref.planId,
      stripeToken = _ref.stripeToken,
      userId = _ref.userId;

  var payload = _objectSpread({
    effective: effective || IMMEDIATELY,
    msa_id: parseInt(msaId, 10),
    plan_id: planId
  }, consents && {
    consents: consents
  }, conversion && !isEmpty(conversion) && {
    conversion: conversion
  }, giftCode && {
    redemption_code: giftCode
  }, livePlanId && {
    digital_plan_id: livePlanId
  }, locationId && {
    gls_location_id: locationId
  }, stripeToken && {
    payment_token: stripeToken
  });

  return client.subscription.create(userId, payload);
});
export var createLiveSubscription = makeEntityScaffold('SAGA.API.CREATE_LIVE_SUBSCRIPTION', function (client, payload) {
  return client.subscription.createLive(payload);
});
export var createSubscriptionCache = makeEntityScaffold('SAGA.API.CREATE_SUBSCRIPTION_CACHE', function (client, userId, payload) {
  return client.subscription.createCache(userId, payload);
}); // This will suffice for most cases where you need the user's subscription.
// If you need the four last digits of the user's card, please use the `userBillingDetails` entity.
// Calling the endpoint with extended: true results in calls to the Stripe API and is significantly slower.

export var userSubscription = makeEntityScaffold('SAGA.API.SUBSCRIPTION', function (client, userId) {
  return client.subscription.getV2(userId, {
    extended: false
  }).then(function (data) {
    return data.data;
  });
});
export var redeemSubscriptionCode = makeEntityScaffold('SAGA.API.REDEEM_SUBSCRIPTION_CREDIT', function (client, userId, code) {
  return client.subscription.redeem(userId, {
    redemption_code: code
  });
}, {
  defaultKey: 1
});
export var liveSubscription = makeEntityScaffold('SAGA.API.LIVE_SUBSCRIPTION', function (client) {
  return client.subscription.getLive();
});